import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a72216e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a72216e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72216e8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FGOperate: require('C:/Users/xiao9/Desktop/projects/web-tattoo-workspace/components/FG/operate.vue').default,FGDraw: require('C:/Users/xiao9/Desktop/projects/web-tattoo-workspace/components/FG/draw.vue').default})
